<template>
  <div class="qrCode"></div>
</template>

<script>
export default {
  name: "qrCode",
  data() {
    return {};
  },
  created() { },
  mounted() { },
  methods: {},
};
</script>
<style>
.qrCode {
}
</style>
